import { Order } from "./order";

export interface ProviderInformation {
  orderingProviderId?: number;
  orderingProviderDisplayName: string;
  providerNotes?: string;
  approvalType: Order.ApprovalTypeEnum;
  readBackAndVerified?: boolean;
}

export namespace ProviderInformation {
  export function isProviderInformation(
    order: Partial<ProviderInformation>
  ): order is ProviderInformation {
    return getMissingFields(order).length === 0;
  }
  export function getMissingFields(
    order: Partial<ProviderInformation>
  ): Array<string> {
    return ["orderingProviderDisplayName", "approvalType"].filter(
      (field) => !order[field]
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/order-management/providerInformation.ts